<ng-lottie
  [height]="height"
  [width]="width"
  [options]="options"
  (animationCreated)="onAnimate($event)"
  (loopComplete)="onLoopComplete($event)"
  (complete)="onComplete($event)"
  (mouseover)="onMouseOver()"
  (mouseleave)="onMouseLeave()"
></ng-lottie>
